module.exports = "/images/Submit_1of5.jpg";